export default "__VITE_ASSET__BTM97D$X__"